import qnetLogo from "../../assets/qnet-with-text-logo.svg";
import { useState, useEffect } from "react";

interface Props {
  setAreaCode: (areaCode: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setEnterCode: (enterCode: boolean) => void;
  emailLogin: () => void;
  sendOTP: () => void;
  email: string;
  password: string;
  phoneNumber: string;
  setForgotPassword: (forgotPassword: boolean) => void;
}

export function EnterPhoneNumber(props: Props) {
  const [useEmail, setUseEmail] = useState(true);

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      if (
        (useEmail && props.email.length > 4 && props.password.length > 4) ||
        (!useEmail && props.phoneNumber.length > 7)
      ) {
        useEmail ? props.emailLogin() : props.sendOTP();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.email, props.password, props.phoneNumber, useEmail]);

  return (
    <div className="flex aspect-square max-h-[700px] min-h-[500px] w-full justify-center max-[768px]:w-[100%]">
      <div className="flex w-full flex-col max-[768px]:max-w-[100%]">
        <div className="flex items-center justify-start pt-[2vh]"></div>

        <div className="flex max-h-[500px] w-full flex-1 flex-col items-baseline justify-center pl-8 pr-8">
          <img
            className="mb-4 h-[100%] max-h-[85px]"
            src={qnetLogo}
            alt="QNET Logo"
          />
          <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
            <span className="text-[32px] text-[black]">
              Welcome back to <b>Qnet™</b> 👋
            </span>
          </div>

          <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
            <span className="text-[14px] text-[#333333]">
              {useEmail
                ? "Enter your email and password to login to your account"
                : "Enter your mobile phone number to login to your account"}
            </span>
          </div>

          {useEmail ? (
            <div className="flex w-[100%] flex-col pt-[16px]">
              <div className="label">
                <span className="label-text text-[#333333]">Email*</span>
              </div>
              <div className="flex items-center">
                <input
                  onChange={(e) => props.setEmail(e.target.value)}
                  type="text"
                  placeholder="Email Address"
                  className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                />
              </div>

              <div className="label">
                <span className="label-text text-[#333333]">Password*</span>
              </div>
              <div className="flex items-center">
                <input
                  onChange={(e) => props.setPassword(e.target.value)}
                  type="password"
                  placeholder="Password"
                  className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                />
              </div>
            </div>
          ) : (
            <div className="flex w-[100%] flex-col pt-[16px]">
              <div className="label">
                <span className="label-text text-[#333333]">
                  Mobile Number*
                </span>
              </div>
              <div className="flex items-center gap-x-[8px]">
                <select
                  className="select select-bordered w-[85px] border-[grey] bg-[white] text-[black]"
                  onChange={(e) => props.setAreaCode(e.target.value)}
                >
                  <option>+1</option>
                  <option>+52</option>
                </select>
                <input
                  onChange={(e) => props.setPhoneNumber(e.target.value)}
                  type="text"
                  placeholder="Mobile Number"
                  className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                />
              </div>
            </div>
          )}
          <div className="flex w-[100%] items-center justify-start pt-[20px]">
            <button
              disabled={
                (useEmail &&
                  (props.email.length <= 4 || props.password.length <= 4)) ||
                (!useEmail && props.phoneNumber.length <= 7)
              }
              onClick={() => (useEmail ? props.emailLogin() : props.sendOTP())}
              className="btn w-full border-none bg-[#fedd00] text-black hover:bg-[#fedd00] disabled:bg-[#fedd00] disabled:text-[black] disabled:opacity-60"
            >
              Continue
            </button>
          </div>

          {!useEmail && (
            <div className="flex items-center justify-start pt-[20px]">
              <span className="text-[14px] text-[#CCCFD1]">
                By providing your mobile number, you agree that it may be used
                to send you text messages about your quality liaison services.
              </span>
            </div>
          )}
          <div className="flex items-center justify-start pt-[20px]">
          <span className="text-[14px] text-[#333333]">
            {'By logging in, you agree to our '}
          </span>
          <a
            className="pl-1 text-blue-600 visited:text-purple-600 text-[14px] underline"
            href={'https://teamqualityservices.com/terms/'}>
              Terms of Service.
          </a>
        </div>
        </div>
        
        <div className="border[grey] border-b-[1px] pt-[50px]"></div>

        {useEmail ? (
          <div
            onClick={() => setUseEmail(false)}
            className="flex items-center justify-center pb-[5vh] pt-[14px] text-[#fedd00] hover:cursor-pointer"
          >
            <span>Use Phone Number instead</span>
          </div>
        ) : (
          <div
            onClick={() => setUseEmail(true)}
            className="flex items-center justify-center pb-[5vh] pt-[14px] text-[#fedd00] hover:cursor-pointer"
          >
            <span>Use Email and Password instead</span>
          </div>
        )}
        <div
            onClick={() => props.setForgotPassword(true)}
            className="flex items-center justify-center pb-[5vh] text-[#fedd00] hover:cursor-pointer"
          >
            <span>Forgot Password</span>
          </div>
      </div>
    </div>
  );
}
